<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 面会スケジュールの公開予約日時
        span.validation-label 必須
      .right-side
        slot(name="question")

    .register-value
      .d-flex.flex-row.align-items-center.flex-wrap
        span(style="margin-left:0px;") 前月の
        //- 日
        select.register-form.input-select(
          v-model="_value.date"
          :name="name + '-date'"
          v-validate="{ required: true }"
          data-vv-as="面会スケジュールの公開予約日時（日）"
          :class="{ noinput: _value == null }"
          style="width:90px;"
        )
          option(v-for="option in _dateOptions" :value="option.value") {{ option.label }}
        span 日
        //- 時
        select.register-form.input-select(
          v-model="_value.hour"
          :name="name + '-hour'"
          v-validate="{ required: true }"
          data-vv-as="面会スケジュールの公開予約日時（時）"
          :class="{ noinput: _value == null }"
          style="width:90px;"
        )
          option(v-for="option in _hourOptions" :value="option.value") {{ option.label }}
        span 時

    .error-messages(v-for="error in errors.collect('publish-datetime-date')")
      label.error-message {{ error }}
      br
    .error-messages(v-for="error in errors.collect('publish-datetime-hour')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { PublishDatetime } from "@/commons/services/ReservationSettings";

@Component
export default class InputPublishDatetime extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: PublishDatetime;

  @Prop()
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): PublishDatetime {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: PublishDatetime) {
    this.$emit("input", newValue);
    return;
  }

  get _dateOptions(): Array<{ value: number; label: string }> {
    const options: Array<{ value: number; label: string }> = [];
    for (let i = 1; i < 32; i++) {
      options.push({
        label: String(i),
        value: i
      });
    }
    return options;
  }

  get _hourOptions(): Array<{ value: number; label: string }> {
    const options: Array<{ value: number; label: string }> = [];
    for (let i = 0; i < 24; i++) {
      options.push({
        label: String(i),
        value: i
      });
    }
    return options;
  }
}
</script>

<style lang="scss" scoped>
.right-side {
  margin-left: 8px;
}
</style>
